<template>
  <div>
    <b-modal id="modalEditNASlistSetting" ref="modalEditNASlistSetting" title='NAS' hide-footer @shown="shown" size="lg">
      <div v-if="editItem">
        <b-tabs vertical pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" v-if="editItem.nas_id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.nas_id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" label='NAS IP' :disabled="editItem.nas_id != 0" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.ip_address" aria-describedby="inputFeedbackName" :state="editItem.ip_address.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter IP') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" label="Auth secret" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.auth_secret"/>
            </b-form-group>
            <b-form-group label-align="right" label="Acc secret" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.acct_secret"/>
            </b-form-group>
            <b-form-group label-align="right" label="DAC secret" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.dac_secret"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('DAE server port')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.das_port"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('ISG profile')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.isg_profile" :options="ISGprofile"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Send disconnect request')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch size="lg" v-model="isDisconnectRequest"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Send CoA request')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch size="lg" v-model="isCoARequest"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Parameters')">
            <md-button class="md-raised" @click="addParameter">{{ $t('Add') }}</md-button>
            <b-row v-for="item in this.parameters" :key="item.numParam" >
              <b-col style="padding-right:0px;">
                <b-select v-model="item.key" :options="allParameters"/>
              </b-col>
              <b-col style="padding-left:0px;padding-right:0px;">
                <b-input v-model="item.value"/>
              </b-col>
              <b-col style="padding-left:5px;padding-right:0px" cols="1">
                <i @click.stop="deleteParam(item)" style="margin-top:0.8rem;" class="danger fa fa-trash-alt fa-lg" />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab v-if="editItem.nas_id != 0" :title="$t('Set RADIUS parameters')">
            <md-button class="md-raised" @click="swohAddRadiusAttr" >{{ $t('Add') }}</md-button>
            <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields" @row-dblclicked="DblClickOnEditRadiusAttrButton" selectable>
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg" />
                <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg" />
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditNASlistSetting')" size="lg"/>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    editItem: null
  },
  data () {
    return {
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 0,
        'attrs': []
      },
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      allParameters: [
        {text: 'radius_auth_vap', value: 'radius_auth_vap'},
        {text: 'radius_auth_h323_remote_address', value: 'radius_auth_h323_remote_address'},
        {text: 'radius_card_autoadd', value: 'radius_card_autoadd'},
        {text: 'send_xpgk_ep_number', value: 'send_xpgk_ep_number'},
        {text: 'send_h323_ivr_in', value: 'send_h323_ivr_in'},
        {text: 'radius_callback_avpair_enable', value: 'radius_callback_avpair_enable'},
        {text: 'radius_acct_rewrite_login_answer', value: 'radius_acct_rewrite_login_answer'},
        {text: 'radius_acct_rewrite_login_originate', value: 'radius_acct_rewrite_login_originate'},
        {text: 'override_service_type', value: 'override_service_type'},
        {text: 'interim_update_interval', value: 'interim_update_interval'},
        {text: 'radius_default_session_timeout', value: 'radius_default_session_timeout'},
        {text: 'radius_ippool_acct_timeout', value: 'radius_ippool_acct_timeout'},
        {text: 'radius_ippool_timeout', value: 'radius_ippool_timeout'},
        {text: 'tel_session_timeout', value: 'tel_session_timeout'},
        {text: 'blocked_pool_name', value: 'blocked_pool_name'},
        {text: 'guest_pool_name', value: 'guest_pool_name'},
        {text: 'h323_currency', value: 'h323_currency'},
        {text: 'h323_origin_reject', value: 'h323_origin_reject'},
        {text: 'incoming_trunk_format', value: 'incoming_trunk_format'},
        {text: 'outgoing_trunk_format', value: 'outgoing_trunk_format'},
        {text: 'pbx_id_format', value: 'pbx_id_format'}
      ],
      numParam: 0,
      parameters: [],
      isCoARequest: false,
      isDisconnectRequest: false,
      radItemForEdit: null
    }
  },
  methods: {
    save () {
      if (!this.editItem.ip_address) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('NAS IP fields is invalid'), 'Error')
        return
      }
      if (this.editItem.ip_address.includes(':')) {
        if (!this.validationIPv6()) {
          return
        }
      } else {
        if (!this.validationIPv4()) {
          return
        }
      }
      for (var i = 1; i < this.parameters.length; i++) {
        for (var j = i - 1; j >= 0; j--) {
          if (this.parameters[j].key === this.parameters[i].key) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('NAS settings: table data is invalid'), 'Error')
            return
          }
        }
      }
      for (let el of this.parameters) {
        if (el.key === 'radius_auth_vap' || el.key === 'radius_auth_h323_remote_address' || el.key === 'radius_card_autoadd' ||
        el.key === 'send_xpgk_ep_number' || el.key === 'send_h323_ivr_in' || el.key === 'radius_callback_avpair_enable' ||
        el.key === 'radius_acct_rewrite_login_answer' || el.key === 'radius_acct_rewrite_login_originate' || el.key === 'override_service_type') {
          if (el.value === '1' || el.value === '0' || el.value === 'true' || el.value === 'false') {
          } else {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('NAS settings: table data is invalid'), 'Error')
            return
          }
        }
        if (el.key === 'interim_update_interval' || el.key === 'radius_default_session_timeout' ||
        el.key === 'radius_ippool_acct_timeout' || el.key === 'radius_ippool_timeout' || el.key === 'tel_session_timeout') {
          let num = Number(JSON.parse(JSON.stringify(el.value)))
          if (!Number(num)) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('NAS settings: table data is invalid'), 'Error')
            return
          }
        }
        if (el.key === 'incoming_trunk_format' || el.key === 'outgoing_trunk_format' || el.key === 'pbx_id_format') {
          try {
            RegExp(el.value)
          } catch (err) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('NAS settings: table data is invalid'), 'Error')
            return
          }
        }
      }

      if (this.isCoARequest && this.isDisconnectRequest) {
        this.editItem.flags = 3
      }
      if (!this.isCoARequest && this.isDisconnectRequest) {
        this.editItem.flags = 2
      }
      if (this.isCoARequest && !this.isDisconnectRequest) {
        this.editItem.flags = 1
      }
      if (!this.isCoARequest && !this.isDisconnectRequest) {
        this.editItem.flags = 0
      }
      if (this.editItem.das_port) {
        this.editItem.das_port = Number(this.editItem.das_port)
      } else {
        this.editItem.das_port = 0
      }
      this.editItem.parameters = this.parameters

      let response = this.editItem.nas_id !== 0
        ? this.$store.dispatch('Settings/UPDATE_NAS_LIST', this.editItem)
        : this.$store.dispatch('Settings/CREATE_NAS_LIST', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          if (this.editItem.nas_id) {
            this.radiusAttr.attrs = this.radiusAttrItems
            this.radiusAttr.set_object_id = this.editItem.nas_id
            this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttr)
          }
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_NAS_LIST')
          this.$refs.modalEditNASlistSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    addParameter () {
      let newParameter = {
        num: 0,
        key: 'radius_auth_vap',
        value: ''
      }
      newParameter.num = ++this.numParam
      this.parameters.push(newParameter)
    },
    deleteParam (item) {
      this.parameters = this.parameters.filter((el, idx, arr) => {
        return el.num !== item.num
      })
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    DblClickOnEditRadiusAttrButton (item) {
      this.rowRadiusAttr = item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    async shown () {
      this.numParam = 0
      this.parameters = []
      if (this.editItem.nas_id) {
        await this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_NAS_LIST', this.editItem.nas_id)
        this.radiusAttrItems = this.$store.getters['Tariffing/RADIUS_ATTR']
        for (let i in this.radiusAttrItems) {
          this.radiusAttrItems[i].value = this.radiusAttrItems[i].attr_value
          if (this.radiusAttrItems[i].tag && (this.radiusAttrItems[i].vendor === 0)) {
            this.radiusAttrItems[i].value = ':' + this.radiusAttrItems[i].tag + ':' + this.radiusAttrItems[i].attr_value
          }
          switch (this.radiusAttrItems[i].attr_type) {
            case 1:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
        for (let el of this.editItem.parameters) {
          el.num = ++this.numParam
        }
        this.parameters = this.editItem.parameters
      }
      switch (this.editItem.flags) {
        case 0:
          this.isDisconnectRequest = false
          this.isCoARequest = false
          break
        case 1:
          this.isDisconnectRequest = false
          this.isCoARequest = true
          break
        case 2:
          this.isDisconnectRequest = true
          this.isCoARequest = false
          break
        case 3:
          this.isDisconnectRequest = true
          this.isCoARequest = true
          break
      }
    },
    validationIPv4 () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      let valIP = this.editItem.ip_address.split('/')[0]
      if (valIP.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationIPv6 () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      let valIP = this.editItem.ip_address.split('/')[0]
      if (valIP.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    }
  },
  computed: {
    ISGprofile () {
      let copy = this.$store.getters['Settings/ISG_PROFILE']
      let ISGprofile = []
      for (let el of copy) {
        let newISGprofile = {
          value: 0,
          text: ''
        }
        newISGprofile.value = el.id
        newISGprofile.text = el.name + ' (' + el.id + ')'
        ISGprofile.push(newISGprofile)
      }
      let newISGprofile = {
        value: 0,
        text: this.$i18n.t('not select')
      }
      ISGprofile.push(newISGprofile)
      return ISGprofile
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/NASlist/editModal.vue